export default "__VITE_ASSET__COPiu9Mj__"